<div class="forgot-container">
  <button
    mat-icon-button
    type="button"
    class="theme-toggle"
    [attr.aria-label]="(isDarkMode$ | async) ? 'Enable light mode' : 'Enable dark mode'"
    (click)="toggleTheme()">
    <mat-icon>{{ (isDarkMode$ | async) ? 'light_mode' : 'dark_mode' }}</mat-icon>
  </button>

  <mat-card class="forgot-card">
    <mat-card-header>
      <mat-card-title>The Big Data Showroom (TBDS)</mat-card-title>
      <mat-card-subtitle *ngIf="step === 'email'">Forgot your password?</mat-card-subtitle>
      <mat-card-subtitle *ngIf="step === 'otp'">Verify OTP to continue</mat-card-subtitle>
      <mat-card-subtitle *ngIf="step === 'done'">Check your email</mat-card-subtitle>
    </mat-card-header>

    <mat-card-content>
      <form *ngIf="step === 'email'" [formGroup]="emailForm" (ngSubmit)="requestOtp()" autocomplete="on">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Email</mat-label>
          <input
            matInput
            type="email"
            formControlName="email"
            name="username"
            autocomplete="username"
            autocapitalize="none"
            spellcheck="false"
            required>
          <mat-error *ngIf="emailForm.get('email')?.hasError('required')">
            Email is required
          </mat-error>
          <mat-error *ngIf="emailForm.get('email')?.hasError('email')">
            Invalid email format
          </mat-error>
        </mat-form-field>

        <button
          mat-raised-button
          color="primary"
          type="submit"
          class="full-width submit-button"
          [disabled]="emailForm.invalid || loading">
          <mat-spinner diameter="20" *ngIf="loading" style="display: inline-block; margin-right: 8px;"></mat-spinner>
          {{ loading ? 'Sending OTP...' : 'Send OTP' }}
        </button>
      </form>

      <form *ngIf="step === 'otp'" [formGroup]="otpForm" (ngSubmit)="verifyOtp()">
        <p class="helper-text">
          Enter the 4 digit OTP sent to <strong>{{ submittedEmail }}</strong>.
        </p>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>OTP Code</mat-label>
          <input matInput type="text" formControlName="otp" maxlength="4" required autocomplete="one-time-code">
          <mat-error *ngIf="otpForm.get('otp')?.hasError('required')">
            OTP is required
          </mat-error>
          <mat-error *ngIf="otpForm.get('otp')?.hasError('pattern')">
            OTP must be 4 digits
          </mat-error>
        </mat-form-field>

        <button
          mat-raised-button
          color="primary"
          type="submit"
          class="full-width submit-button"
          [disabled]="otpForm.invalid || loading">
          <mat-spinner diameter="20" *ngIf="loading" style="display: inline-block; margin-right: 8px;"></mat-spinner>
          {{ loading ? 'Verifying OTP...' : 'Verify OTP' }}
        </button>

        <button mat-button type="button" class="full-width secondary-action" (click)="backToEmail()" [disabled]="loading">
          Use a different email
        </button>
      </form>

      <div *ngIf="step === 'done'" class="success-box">
        <h3>Reset email sent</h3>
        <p>
          If your OTP was valid, we sent a password reset email to <strong>{{ submittedEmail }}</strong>.
          Open the link in that email to set your new password.
        </p>
        <button mat-raised-button color="primary" class="full-width" (click)="goToLogin()">
          Back to login
        </button>
      </div>

      <button *ngIf="step !== 'done'" mat-button type="button" class="full-width secondary-action" (click)="goToLogin()" [disabled]="loading">
        Back to login
      </button>
    </mat-card-content>
  </mat-card>
</div>
